import React, { useState, useEffect, useRef } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import TileProduct from './tile-product'
import TilePk from './tile-pk'
import TileVintage from './tile-vintage'
import { jnstyls } from '~/utils/helpers'

import * as styles from "~/styles/tiles/tile.module.scss"

const Tile = ({ product, tile_ind, is_plp, flats, show, handleQuick=false }) => {
  const { isMobile } = useTheme()
  const [isInView, setIsInView] = useState(false)
  const tileRef = useRef(null)
  
  const is_pk = product.pl_pima === 99998
  const is_story = is_pk && !!product.pkstory
  
  useEffect(() => {
    const currtile = tileRef.current
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsInView(entry.isIntersecting);
        });
      },
      {
        root: null, 
        rootMargin: isMobile ? '100%' : '50%', 
        threshold: 0.1 
      },
    );

    if (is_pk) {
      tileRef.current.setAttribute('ab','true')
    }

    if (currtile) {
      observer.observe(currtile);
    }

    return () => {
      if (currtile) {
        observer.unobserve(currtile);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div 
      className={jnstyls([styles.tile, is_pk ? styles.info_tile : '',(is_story && product.pkstory.show_two) ? styles.tile2 : ''])}
      id={product.mid}
      handle={product.handle}
      ref={tileRef} 
      tile=""
    >
      {(!is_pk && !product.is_vintage) && (
        <TileProduct 
          product={product} 
          tile_ind={tile_ind} 
          is_plp={is_plp} 
          flats={flats} 
          isInView={isInView} 
          handleQuick={handleQuick} 
        />
      )}
      {is_pk && (
        <TilePk product={product} tile_ind={tile_ind} isInView={isInView} />
      )}
      {product.is_vintage && (
        <TileVintage product={product} tile_ind={tile_ind} is_plp={is_plp} flats={flats} isInView={isInView} />
      )}
    </div>
  )
};

export default Tile
